import { config, EntityType } from '@cime/breeze-client';
var UriBuilderJsonAdapter = /** @class */function () {
  function UriBuilderJsonAdapter() {
    this.name = "json";
  }
  UriBuilderJsonAdapter.register = function () {
    config.registerAdapter("uriBuilder", UriBuilderJsonAdapter);
    return config.initializeAdapterInstance("uriBuilder", "json", true);
  };
  UriBuilderJsonAdapter.prototype.initialize = function () {};
  UriBuilderJsonAdapter.prototype.buildUri = function (entityQuery, metadataStore) {
    // force entityType validation;
    var entityType = entityQuery._getFromEntityType(metadataStore, false);
    if (!entityType) entityType = new EntityType(metadataStore);
    var json = entityQuery.toJSONExt({
      entityType: entityType,
      toNameOnServer: true
    });
    json.from = undefined;
    json.queryOptions = undefined;
    if (json.parameters && json.parameters.$data) {
      // remove parameters if doing ajax post
      json.parameters = undefined;
    }
    var jsonString = JSON.stringify(json);
    if (jsonString.length > 2) {
      var urlBody = encodeURIComponent(jsonString);
      var sep = entityQuery.resourceName.includes("?") ? "&" : "?";
      return entityQuery.resourceName + sep + "query=" + urlBody;
    } else {
      return entityQuery.resourceName;
    }
  };
  return UriBuilderJsonAdapter;
}();
config.registerAdapter("uriBuilder", UriBuilderJsonAdapter);

/**
 * Generated bundle index. Do not edit.
 */

export { UriBuilderJsonAdapter };